import useSWR from 'swr'

import {
  FtpSettingsApiPath,
  ListFtpConnectionsResponse,
  ListFtpConnectionsVars
} from '@/common/api/params/ftpSettings'

export const useFtpConnectionsGetApi = () => {
  return useSWR<ListFtpConnectionsResponse, Response, [string, ListFtpConnectionsVars]>([
    FtpSettingsApiPath.LIST_FTP_CONNECTIONS,
    {}
  ])
}
